export default __webpack_public_path__ + "static/media/step.47bb4036.png";